export default "__VITE_ASSET__1ce008c8__"